if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.addEventListener('keydown', this.onKeyDown.bind(this));
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      // showActiveMedia() {
      //   this.querySelectorAll(
      //     `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
      //   ).forEach((element) => {
      //     element.classList.remove('active');
      //   });
      //   const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
      //   const activeMediaTemplate = activeMedia.querySelector('template');
      //   const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      //   activeMedia.classList.add('active');
      //   activeMedia.scrollIntoView();

      //   const container = this.querySelector('[role="document"]');
      //   container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      //   if (
      //     activeMedia.nodeName == 'DEFERRED-MEDIA' &&
      //     activeMediaContent &&
      //     activeMediaContent.querySelector('.js-youtube')
      //   )
      //     activeMedia.loadContent();
      // }

      showActiveMedia() {
        const targetMediaId = this.openedBy.getAttribute('data-media-id');

        // Remove old active classes
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${targetMediaId}"])`)
          .forEach((element) => element.classList.remove('active'));

        const activeMedia = this.querySelector(`[data-media-id="${targetMediaId}"]`);
        const activeMediaTemplate = activeMedia?.querySelector('template');
        const activeMediaContent = activeMediaTemplate?.content;

        if (activeMedia) {
          activeMedia.classList.add('active');
          activeMedia.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }

        // Locate Swiper instance inside the modal
        const swiperContainer = this.querySelector('.swiper');
        const swiperInstance = swiperContainer?.swiper;

        if (swiperInstance) {
          // Find the slide containing the active media element
          const targetSlide = Array.from(swiperInstance.slides).find((slide) =>
            slide.querySelector(`[data-media-id="${targetMediaId}"]`)
          );

          if (targetSlide) {
            const targetIndex = swiperInstance.slides.indexOf(targetSlide);
            swiperInstance.slideTo(targetIndex, 500); // This sets swiper-slide-active correctly
          }
        }

        const container = this.querySelector('[role="document"]');
        if (activeMedia && container) {
          container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;
        }

        // Load YouTube video if needed
        if (
          activeMedia?.nodeName === 'DEFERRED-MEDIA' &&
          activeMediaContent?.querySelector('.js-youtube')
        ) {
          activeMedia.loadContent();
        }
      }

      onKeyDown(event) {
        if (!this.hasAttribute('open')) return;

        const swiperInstance = this.querySelector('.product-media-modal__content.swiper')?.swiper;
        if (!swiperInstance) return;

        if (event.code === 'ArrowLeft') {
          event.preventDefault();
          swiperInstance.slidePrev();
        }

        if (event.code === 'ArrowRight') {
          event.preventDefault();
          swiperInstance.slideNext();
        }
      }
    }
  );
}
